import { render } from "./SchedulesDialog.vue?vue&type=template&id=72d34da0"
import script from "./SchedulesDialog.vue?vue&type=script&lang=js"
export * from "./SchedulesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__